import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceIssueArchivalRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-issue',
	path: '/jira/settings/system/performance/metrics/issue',
};
